import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { take } from 'rxjs/operators';
import { LoginStorage } from '../login.storage';
import { StorageService } from '../../services/storage/storage.service';
import { LoginService } from '../login.service';
import { LoginAgente } from '../model/login-agente';
import { AgenteService } from '../../services/pesados-brasil/agente.service';
import { LoginParamsUtil } from '../../login/login-params.util';

@Component({
  selector: 'app-auth-redirect',
  templateUrl: './auth-redirect.component.html',
  styleUrls: ['./auth-redirect.component.scss']
})
export class AuthRedirectComponent implements OnInit {

  queryParams!: Params;
  pathParams!: Params;
  agent: LoginAgente | null = null;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private storageService: StorageService,
    private loginStorage: LoginStorage,
    private loginService: LoginService,
    private agentService: AgenteService,
    private loginParams: LoginParamsUtil
  ) { }

  ngOnInit(): void {
    const currentRoute = this.route.snapshot.root;
    const pathParams = currentRoute.firstChild.params || {};

    this.pathParams = this.decodePathParams(pathParams);
    this.queryParams = currentRoute.queryParams || {};

    this.setAgent();
    this.validate();
    this.setOptions();
  }

  setAgent() {
    const agentParam = this.queryParams['agent'];
    if (!agentParam) return;
    try {
      this.agent = JSON.parse(atob(decodeURIComponent(agentParam)));
    } catch {
      this.agent = null;
    }
  }

  setOptions() {
    const options = this.queryParams['options'];
    if (!options) return;
    try {
      const decodedOptions = JSON.parse(atob(decodeURIComponent(options)));
      this.loginParams.setOptions(decodedOptions);
    } catch {
      this.loginParams.setOptions(null);
    }
  }

  decodePathParams(pathParams: Params): Params {
    return Object.keys(pathParams).reduce(
      (acc, key) => {
        acc[key] = atob(decodeURIComponent(pathParams[key]));
        return acc;
      },
      {}
    );
  }

  validate() {
    this.storageService.renewUser(JSON.stringify(this.pathParams))
      .pipe(take(1))
      .subscribe(
        (result) => {
          this.loginStorage.register(result.usuario);
          this.loginStorage.registerDataExpiracao(result.dataExpiracao);
          this.selectAgent();
        },
        () => this.goToLogin()
      );
  }

  selectAgent() {
    if (!this.agent) {
      this.goToLogin();
      return;
    }
    this.loginService
      .selecionarAgente(this.agent.id.toString())
      .pipe(take(1))
      .subscribe(
        () => this.onSelectAgentSuccess(),
        () => this.goToLogin());
  }

  async onSelectAgentSuccess() {
    this.loginStorage.registerAgente(this.agent);
    try {
      const result = await this.agentService.getOriginador().toPromise();
      this.loginStorage.registerOriginator(result);
    } catch (error) {
      this.loginStorage.registerOriginator(null);
    } finally {
      this.loginParams.setLoginParams();
      this.goToRedirect();
    }
  }

  private goToLogin() {
    this.router.navigate(['/login']);
  }

  goToRedirect() {
    this.router.navigateByUrl(this.queryParams['redirectUrl'] || '/');
  }

}
